import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DropzoneState } from 'react-dropzone';
import { TextStdRg } from '@/UI/AppTypography/AppTypography';
import { color } from '@/colors';
import { Input } from '@/UI/Input/Input';
import { UploadIcon } from '@/UI/Icons/UploadIcon';
import { FlexColCenHorVer, FlexCenHorVer, FlexCol } from '@/UI/styles';
import { I18N_KEYS } from '../../../language/keys';

export type UploadFormProps = {
  allowUrlInput: boolean;
  getInputProps: DropzoneState['getInputProps'];
  onLinkUpload: (link: string) => Promise<void>;
  isSelected?: boolean;
};

export const UploadForm = ({ allowUrlInput, getInputProps, onLinkUpload, isSelected }: UploadFormProps) => {
  const { t } = useTranslation();
  const [isFocused, setIsFocused] = useState(false);
  const [fileLink, setFileLink] = useState('');

  const handleLinkPaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const pastedText = event.clipboardData.getData('text');
    setFileLink(pastedText);
    void onLinkUpload(pastedText);
  };
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFileLink(event.target.value);
  };
  const handleInputClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  return (
    <FlexColCenHorVer
      sx={{
        textAlign: 'center',
      }}
    >
      <FlexCenHorVer
        sx={{
          flexDirection: allowUrlInput ? 'column' : 'row',
          gap: 2,
          width: '100%',
        }}
      >
        <FlexColCenHorVer
          className="media-container-dark"
          sx={{
            border: '1px solid',
            bgcolor: color.Black92,
            borderColor: color.White04_T,
            borderRadius: 2,
            cursor: 'pointer',
            height: '430px',
            width: '100%',
            gap: 1,
          }}
        >
          <input {...getInputProps()} />
          <UploadIcon />
          <TextStdRg data-testid="file-upload-cta" color={color.White100}>
            {t(I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.CTA)}
          </TextStdRg>
        </FlexColCenHorVer>
        {allowUrlInput ? (
          <FlexCol
            sx={{
              gap: 1,
              width: '100%',
              opacity: isSelected ? 1 : 0,
              transition: 'all 0.1s ease',
            }}
            onClick={handleInputClick}
          >
            <Input
              className={isFocused ? 'nowheel nodrag nopan' : ''}
              onFocus={() => {
                setIsFocused(true);
              }}
              onBlur={() => {
                setIsFocused(false);
              }}
              type="text"
              placeholder={t(I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.PASTE_LINK)}
              value={fileLink}
              onChange={handleInputChange}
              onPaste={(event: React.ClipboardEvent<HTMLInputElement>) => handleLinkPaste(event)}
              fullWidth
              size="large"
            />
          </FlexCol>
        ) : null}
      </FlexCenHorVer>
    </FlexColCenHorVer>
  );
};
